import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel, DocumentWithPassCodeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class PurchaseOrderService {
  DoGetPurchaseOrderDocumentPublicLink(input: DocumentWithPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Quotation/GetPurchaseOrderDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetPurchaseOrderDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Quotation/GetPurchaseOrderDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdatePurchaseOrderDetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Quotation/UpdatePurchaseOrderDetailDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new PurchaseOrderService();
